"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Scout = _interopRequireDefault(require("./core/Scout"));

var _track = _interopRequireDefault(require("./core/track"));

var _sensors = _interopRequireDefault(require("./core/sensors"));

var _baseData = _interopRequireDefault(require("./core/base-data"));

var _pageView = _interopRequireDefault(require("./core/page-view"));

var _request = _interopRequireDefault(require("./core/request"));

var _fetchDuration = _interopRequireDefault(require("./core/fetch-duration"));

var _moduleView = _interopRequireDefault(require("./core/module-view"));

var _moduleClick = _interopRequireDefault(require("./core/module-click"));

var _pageOpen = _interopRequireDefault(require("./core/page-open"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scout = new _Scout["default"]();
scout.use(_baseData["default"]);
scout.use(_sensors["default"]);
scout.use(_track["default"]);
scout.use(_pageView["default"]);
scout.use(_request["default"]);
scout.use(_fetchDuration["default"]);
scout.use(_moduleView["default"]);
scout.use(_moduleClick["default"]);
scout.use(_pageOpen["default"]);
var _default = scout;
exports["default"] = _default;